import { Card, CardContent } from "@/components/ui/card";

const integrations = [
{
  name: "Email",
  icon: "✉️",
  description: "Connect with Gmail, Outlook, and other email providers"
},
{
  name: "Spreadsheets",
  icon: "📊",
  description: "Sync with Google Sheets, Excel, and Airtable"
},
{
  name: "Calendar",
  icon: "📅",
  description: "Integrate with Google Calendar, Outlook Calendar"
},
{
  name: "CRM",
  icon: "🤝",
  description: "Connect to Salesforce, HubSpot, and Zoho"
},
{
  name: "E-commerce",
  icon: "🛒",
  description: "Work with Shopify, WooCommerce, and Magento"
},
{
  name: "Social Media",
  icon: "📱",
  description: "Post to LinkedIn, Twitter, Instagram, and Facebook"
},
{
  name: "Cloud Storage",
  icon: "☁️",
  description: "Access Google Drive, Dropbox, and OneDrive"
},
{
  name: "Messaging",
  icon: "💬",
  description: "Integrate with WhatsApp, Slack, and Teams"
}];


export default function IntegrationSection() {
  return (
    <section className="py-16 bg-gray-50" data-id="idgn3klt5" data-path="src/components/home/IntegrationSection.tsx">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="ibzpeh6uv" data-path="src/components/home/IntegrationSection.tsx">
        <div className="text-center mb-12" data-id="20hn67a9d" data-path="src/components/home/IntegrationSection.tsx">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="fi7qc2dkb" data-path="src/components/home/IntegrationSection.tsx">
            Seamless Integrations
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-id="rmcwerrp0" data-path="src/components/home/IntegrationSection.tsx">
            Our AI automation solutions connect with all your favorite tools and platforms,
            creating a unified workflow that saves you time and effort.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="dqnttj9o4" data-path="src/components/home/IntegrationSection.tsx">
          {integrations.map((integration, index) =>
          <Card key={index} className="border border-gray-200 hover:shadow-md transition-shadow" data-id="xivm6qsic" data-path="src/components/home/IntegrationSection.tsx">
              <CardContent className="p-6 text-center" data-id="5axg0p9zq" data-path="src/components/home/IntegrationSection.tsx">
                <div className="text-5xl mb-4" data-id="7hjw7mmdj" data-path="src/components/home/IntegrationSection.tsx">{integration.icon}</div>
                <h3 className="text-xl font-medium text-gray-900 mb-2" data-id="44axe1ril" data-path="src/components/home/IntegrationSection.tsx">{integration.name}</h3>
                <p className="text-gray-600 text-sm" data-id="ajqlr3vu3" data-path="src/components/home/IntegrationSection.tsx">{integration.description}</p>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </section>);

}